export { default } from './ProgressCircular.vue'
